import {
  HeadingGroup,
  ModalLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../Global/OrderColumn";
import EmptyData from "../../Global/EmptyData";
import useAiSettings from "./useAiSettings";
import AddUsers from "./AddUsers";

const AiSettings = () => {
  const {
    isLoading,
    isFetching,
    showEditModal,
    paginationOptions,
    aiSettingsList,
    aiSettingsState,
    closeModal,
    setAiSettingsState,
    handleEditAction,
    updateAisettingsTableHeadData,
    handleEditColumnsClick,
    handlePagination,
    handleClearClick,
    handlePageSize,
    handleSearch,
    handleSort,
    refetch,
    getRow,
  } = useAiSettings();
  return (
    <>
      <HeadingGroup title="Ai Settings" className={`pro-mb-4`}></HeadingGroup>
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          handleClear={handleClearClick}
          searchInputProps={{ value: aiSettingsState?.search }}
          handleActionClick={handleEditColumnsClick}
          searchable={true}
        />
        {aiSettingsList?.data?.result?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={aiSettingsList?.data?.result || []}
            uniqueID={"_id"}
            fields={aiSettingsList?.fields || {}}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            handleEdit={handleEditAction}
            handleSort={handleSort}
            getRow={getRow}
            loading={isFetching}
            clear={aiSettingsState?.clearSelection}
            perpage={aiSettingsState?.currentPageSize}
            assignable={false}
            deletable={false}
            editable={aiSettingsList?.edit_permission}
            showCheckBox={aiSettingsList?.edit_permission}
          />
        )}

        {aiSettingsList?.data?.result?.length > 0 && (
          <Pagination
            currentPage={aiSettingsState?.currentPage}
            totalPageCount={Math.ceil(
              aiSettingsList?.data?.total_count /
                aiSettingsState?.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === aiSettingsState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={aiSettingsList?.fields || []}
              moduleId={aiSettingsList?.module_id}
              updateData={updateAisettingsTableHeadData}
            />
          </div>
        </ModalLayout>
        <ModalLayout
          show={aiSettingsState.showModal}
          handleClose={()=>closeModal()}
          title={`Update Ai Settings `}
          backdrop="static"
        >
          <div className="pro-m-5">
            <AddUsers
              refetch={refetch}
              aiSettingsState={aiSettingsState}
              setAiSettingsState={setAiSettingsState}
            />
          </div>
        </ModalLayout>
      </div>
    </>
  );
};

export default AiSettings;
